import { buildComponent } from '#components/build-component'

export const ProductsSelector = buildComponent({
  name: 'products-selector',
  onConnected(component) {
    const itemEls = component.querySelectorAll('[data-product-selector]')
    const selectAllEl = component.querySelector('[data-product-select-all]')
    const valuesEl: HTMLInputElement | null = component.querySelector('[data-product-values]')
    const setValues = () => {
      if (!itemEls.length || !valuesEl) return

      const selectedProducts: string = [...itemEls]
        .map((itemEl) => {
          if (!itemEl.classList.contains('is-active')) return null
          else return itemEl.getAttribute('data-product-title')
        })
        .filter(Boolean)
        .join(', ')

      valuesEl.value = selectedProducts
    }

    if (itemEls.length) {
      itemEls.forEach((itemEl) => {
        itemEl.addEventListener('click', () => {
          const isActive = itemEl.classList.contains('is-active')

          itemEl.classList.toggle('is-active', !isActive)
          setValues()
        })
      })
    }

    if (selectAllEl) {
      selectAllEl.addEventListener('click', () => {
        if (itemEls.length) {
          itemEls.forEach((itemEl) => {
            itemEl.classList.add('is-active')
          })
        }
        setValues()
      })
    }
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'products-selector': typeof ProductsSelector
  }
}
